import { Facebook, Instagram } from "lucide-react";
import { apiSync } from "@/lib/api";

const TopBar = () => {
  const settings = apiSync.getSiteSettings();

  const social = settings?.social || {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    tiktok: "",
  };

  return (
    <div
      className="w-full text-sm bg-[hsl(68,55%,28%)] text-white h-[60px]"
    >
      <div className="container h-full flex items-center justify-end">
        <div className="flex items-center gap-3">
          {social.facebook && (
            <a
              href={social.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="hover:opacity-80 transition-opacity"
            >
              <Facebook size={24} />
            </a>
          )}
          {social.instagram && (
            <a
              href={social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="hover:opacity-80 transition-opacity"
            >
              <Instagram size={24} />
            </a>
          )}
          {social.tiktok && (
            <a
              href={social.tiktok}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
              className="hover:opacity-80 transition-opacity"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.7a8.18 8.18 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.13z" />
              </svg>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopBar;
